import {Divider, ListItem, ListItemIcon, ListItemText, Stack, styled} from '@mui/material';

const CustomDivider = styled(Divider)`
	margin: 8px 0;
`;

const PreviewItems = styled(ListItem)`
	align-items: flex-start;
`;

const StyledListItemIcon = styled(ListItemIcon)`
	color: ${({theme}) => theme.palette.primary.main};
	margin-right: 8px;
	min-width: unset;
	padding: 2px 0;
	margin-top: 0;
`;

const StyledListItemText = styled(ListItemText)`
	flex-direction: column;
	display: flex;
	margin: 0;
	gap: 8px;

	& .MuiListItemText-primary {
		font-size: 14px;
		font-weight: 400;
		color: ${({theme}) => theme.palette.text.secondary};
	}

	& .MuiListItemText-secondary {
		font-size: 16px;
		font-weight: 400;
		color: ${({theme}) => theme.palette.text.primary};
	}
`;

const StyledStackItems = styled(Stack)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: auto;
	padding-top: 8px 0;

	${({theme}) => theme.breakpoints.down('lg')} {
		flex-direction: column;
		gap: 16px;
	}
`;

const ChipContainer = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: 8px;
`;

export {
	CustomDivider,
	StyledListItemIcon,
	StyledListItemText,
	StyledStackItems,
	ChipContainer,
	PreviewItems,
};
